var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoIconSmallBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-DO"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DO",
    clipPath: "url(#clip-DO)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23216",
    "data-name": "Tracciato 23216",
    d: "M1268.016-10620h-38.268a8.39,8.39,0,0,0-8.366,8.365v38.271a8.39,8.39,0,0,0,8.366,8.364h38.268a8.39,8.39,0,0,0,8.365-8.364v-38.271A8.39,8.39,0,0,0,1268.016-10620Zm-3.769,42.808h-30.731v-30.732h30.731Z",
    transform: "translate(-1216.382 10624.995)",
    fill: "blue"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoIconSmallBlu);
export default __webpack_public_path__ + "static/media/do-icon-small-blu.57ef475a.svg";
export { ForwardRef as ReactComponent };